
import { Avatar, AvatarFallback } from '@/components/ui/avatar';

export interface ChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
  userInitials: string;
}

export const ChatMessage = ({ role, content, userInitials }: ChatMessageProps) => {
  const getUserInitials = (messageRole: 'user' | 'assistant') => {
    if (messageRole === 'assistant') return 'AI';
    return userInitials || 'U';
  };

  return (
    <div className={`flex ${role === 'user' ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`flex max-w-[80%] ${
          role === 'user'
            ? 'flex-row-reverse'
            : 'flex-row'
        }`}
      >
        <Avatar className={`h-8 w-8 ${role === 'user' ? 'ml-2' : 'mr-2'}`}>
          <AvatarFallback>
            {getUserInitials(role)}
          </AvatarFallback>
        </Avatar>
        <div
          className={`px-4 py-3 rounded-lg ${
            role === 'user'
              ? 'bg-primary text-primary-foreground'
              : 'bg-muted'
          }`}
        >
          <p className="text-sm whitespace-pre-line">{content}</p>
        </div>
      </div>
    </div>
  );
};
